export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RESULT_PER_PAGE = 10;
export const KEY = '6b9ddba2-844b-4553-b54b-6addb0c041fc';
export const MODAL_CLOSE_SEC = 2.5;
